import { retailerSchema } from "schemas";
import { apiClient } from "../client";

export const getRetailer = async (retailerId: string) =>
  retailerSchema.parse((await apiClient.get(`retailers/${retailerId}`)).data);
